import { Storage } from 'aws-amplify';

const BUCKET = process.env.REACT_APP_S3_BUCKET || 'videojobfairs-docs-stage';
const PUBLIC_PREFIX = 'public/';

export interface UserManualInfo {
  key: string
  filename: string
  label: string
  publicUrl: string
  exists: boolean
  lastModified?: string
}

export class AdminUserManualService {
  static readonly manuals: Omit<UserManualInfo, 'publicUrl' | 'exists' | 'lastModified'>[] = [
    { key: 'user-manuals/Employer_User_Manual.pdf', filename: 'Employer_User_Manual.pdf', label: 'Employer User Manual' },
    { key: 'user-manuals/JobSeeker_User_Manual.pdf', filename: 'JobSeeker_User_Manual.pdf', label: 'Job Seeker User Manual' }
  ];

  private publicUrl (key: string): string {
    return `https://${BUCKET}.s3.amazonaws.com/${PUBLIC_PREFIX}${key}`;
  }

  async getManuals (): Promise<UserManualInfo[]> {
    const results: UserManualInfo[] = [];
    const files = await Storage.list('user-manuals/');
    for (const m of AdminUserManualService.manuals) {
      const url = this.publicUrl(m.key);
      const file = files.find((item) => item.key === m.key);
      const exists = !!file;
      const lastModified = file?.lastModified?.toISOString();
      results.push({ ...m, publicUrl: url, exists, lastModified });
    }
    return results;
  }

  async uploadManual (key: string, file: File, onProgress?: (pct: number) => void): Promise<string> {
    await Storage.put(key, file, {
      contentType: file.type,
      cacheControl: 'no-cache, max-age=0, must-revalidate',
      progressCallback (progress) {
        if (onProgress) {
          onProgress(Math.round((progress.loaded / progress.total) * 100));
        }
      }
    });
    return this.publicUrl(key);
  }

  async deleteManual (key: string): Promise<void> {
    await Storage.remove(key);
  }
}
